import React from 'react';
import { default as __ } from '../../../utils';
import Title from '../../../components/title';
function Advice(props) {
  let { universe, streakVictories, rivals } = props;

  return (
    <section className="owl">
      <Title value="ADVICE" vertices={7} label="TIME" />
      <div className="owl-xl -pristine">
        <div className="small-container txt-center -purple">
          <p className="txt-xxxl -ultrapurple">{streakVictories}% </p>
          <p>VICTORIAS EN LOS ÚLTIMOS 5 PARTIDOS</p>
          <p className="txt-uppercase txt-l -purple">
            {streakVictories >= 75
              ? 'sigue así'
              : streakVictories >= 90
              ? 'tu evolución es fantástica'
              : 'rise, como Batman'}
          </p>
        </div>
        <div className="small-container txt-center -purple">
          <p className="txt-xxxl -ultrapurple">
            {Math.round((rivals.top / (universe * 2)) * 100)}%{' '}
          </p>
          <p> OPONENTES TOP HISTÓRICO</p>
          <p className="txt-uppercase txt-l -purple">
            {(rivals.top / (universe * 2)) * 100 >= 60
              ? 'sigue así'
              : (rivals.top / (universe * 2)) * 100 >= 80
              ? 'tu evolución es fantástica'
              : 'intenta jugar contra mejores players'}
          </p>
        </div>
      </div>
    </section>
  );
}

export default Advice;
